export default "__VITE_ASSET__8e48b61b__"